import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsEquipment, PmsEquipment } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsEquipment>
    useData={usePmsEquipment}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
